import React from 'react';
import PropTypes from 'prop-types';
import { QuoteProductConfiguration } from '../../../quotes/quoteProductConfiguration';
import { Quote } from '../../../quotes/quote';
import ReviewQuoteCouplerDecision from './ReviewQuoteCouplerDecision';
//import './ReviewQuoteCouplerDecisions.scss';
import { Machine } from '../../../machines/machine';

export default class ReviewQuoteCouplerDecisionsContainer extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    onQuoteUpdated: PropTypes.func.isRequired,
    onloadSharedDocuments: PropTypes.func.isRequired,
    machines: PropTypes.arrayOf(PropTypes.instanceOf(Machine)).isRequired,
  };

  getCouplerStyles = (attachmentPointId) => {
    return this.props.quoteProductConfiguration.couplerStyles.filter(
      (x) => x.attachmentPointId === attachmentPointId
    );
  };

  getFirstCouplerProductGroup(quoteAttachmentPoint) {
    const couplerType = quoteAttachmentPoint.productGroupIdsPerType.find(
      (x) => x.type === 'Coupler'
    );
    return couplerType
      ? this.props.quoteProductConfiguration.productGroups.find(
          (x) => x.id === couplerType.productGroupIds[0]
        )
      : null;
  }

  render() {
    const {
      quote,
      quoteProductConfiguration,
      onloadSharedDocuments,
      machines,
    } = this.props;
    if (quote.attachmentPoints.length === 0) {
      return null;
    }
    const multiAttachmentPoints =
      quoteProductConfiguration.attachmentPoints.length > 1;
    return (
      <div className="row lugging-selections">
        {quote.attachmentPoints.map((quoteAttachmentPoint) => {
          const firstCouplerProductGroup =
            this.getFirstCouplerProductGroup(quoteAttachmentPoint);
          return (
            <ReviewQuoteCouplerDecision
              key={quoteAttachmentPoint.id}
              quote={quote}
              attachmentPoint={quoteProductConfiguration.attachmentPoints.find(
                (x) => x.id === quoteAttachmentPoint.id
              )}
              anyCouplerAffected={!!firstCouplerProductGroup}
              defaultCouplerType={null}
              quoteAttachmentPoint={quoteAttachmentPoint}
              onQuoteAttachmentPointUpdated={(updatedQuote) =>
                this.props.onQuoteUpdated(updatedQuote)
              }
              couplerStyles={this.getCouplerStyles(quoteAttachmentPoint.id)}
              multiAttachmentPoints={multiAttachmentPoints}
              isFromStep3={false}
              onloadSharedDocuments={onloadSharedDocuments}
              machines={machines}
              quoteProductConfiguration={quoteProductConfiguration}
            />
          );
        })}
      </div>
    );
  }
}
